import React, { useContext } from "react";
import "../../../assests/css/studentdashboard/StudentLogout.css";
import { FaSignOutAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { AppContext } from "../../../context/Appcontext";

const StudentLogout = () => {
  const navigate = useNavigate();
  const { setAuthToken } = useContext(AppContext);

  const handleLogout = () => {
    console.log("Logout function called");

    // FIX: authToken bhi remove karo, warna login page turant wapas dashboard bhej dega
    localStorage.removeItem("authToken");
    localStorage.removeItem("studentEmail");
    localStorage.removeItem("studentPassword");
    localStorage.removeItem("student");

    setAuthToken(null); // context bhi turant update karo

    Swal.fire({
      icon: "success",
      title: "Logged Out!",
      text: "Your logout was successful",
      confirmButtonColor: "#6A88CE",
    }).then(() => {
      navigate("/student-register");
    });
  };


  const handleCancel = () => {
    navigate("/student/dashboard");
  };

  return (
    <div className="sp-logout-page">
      <div className="sp-logout-card">
        <FaSignOutAlt className="sp-logout-icon" />
        <h1 className="sp-logout-title">Logout</h1>
        <p className="sp-logout-text">
          Are you sure you want to logout? Your progress is saved.
        </p>
        <div className="sp-logout-btns">
          <button className="sp-logout-confirm" onClick={handleLogout}>
            Yes, Logout
          </button>
          <button className="sp-logout-cancel" onClick={handleCancel}>
            Cancel
          </button>
        </div>
        <p className="sp-logout-note">👋 See you soon!</p>
      </div>
    </div>
  );
};

export default StudentLogout;